import { Component, Inject, ViewChild } from "@angular/core";
import { ActivationStart, Router, RouterOutlet } from "@angular/router";
import { DATA } from "../dialog/dialog.service";

export interface Data {
  area: string;
}

@Component({
  template: '<router-outlet></router-outlet>',
  styleUrls:['./settings.app.scss']
})
export class SettingsApp {

  @ViewChild(RouterOutlet) outlet?: RouterOutlet;

  constructor(private router: Router, @Inject(DATA) data?: Data) {
    router.initialNavigation();

    if(data?.area) {
      router.navigate([data.area]);
    } else {
      router.navigate(['organization']);
    }
  }

  ngOnInit(): void {
    this.router.events.subscribe(e => {
      if (e instanceof ActivationStart && e.snapshot.outlet === "administration")
        this.outlet!.deactivate();
    });
  }

}
